<template lang="html">
	<section class="documents-layout ctn-patrimonial-landscape">
		<article>
			<!-- <div class="ctn-docs-layout">
				<div class="title">
					Documents en attente de signature
				</div>
				<div class="ctn-docs white-box">
					<div class="doc-review row">
						<span class="icon-alert"></span>
						<div class="title-sec column">
							<div class="name">
								Compte rendu de mission #1 - M. Durand
							</div>
							<div class="sub row">
								<div class="number">
									Contrat n° 821821821
								</div>
								<div class="date">
									Ajouté le 29/02/2018
								</div>
							</div>
						</div>
						<div class="btn btn-red">
							Lire et signer
						</div>
					</div>
				</div>
			</div> -->
			<div class="title">
				Documents archivés
			</div>
			<div class="view-nav-template white-box row">
				<div class="menu column" id="side-menu-column">
					<ul class="ctn-menu column">
						<li class="item-main" v-for="(item, key) in menu" v-bind:key="key" :class="{active: isActiveFirst(key)}">
							<div class="label" v-html="item.label" @click="setActiveFirst(key)"></div>
							<ul class="ctn-second" v-if="item.children && isActiveFirst(key)">
								<li class="item-second" v-html="child.label" v-for="(child, keyt) in item.children" v-bind:key="keyt" :class="{active: isActiveSecond(keyt)}" @click="setActiveSecond(keyt)"></li>
							</ul>
						</li>
					</ul>
				</div>
				<div class="view column">
					<div class="title row">
						<div class="inner-title" v-html="menu[activeFirstLevel].label"></div>
						<button id="add-document-btn" class="btn" @click="showAddDocument=true" :disabled="isAnonymous" :class="{'btn-red': !isAnonymous, 'btn-disabled': isAnonymous}">
							Ajouter un document
						</button>
					</div>
					<div class="ctn-component">
						<div class="title-component" v-html="menu[activeFirstLevel].children[activeSecondLevel].label" v-if="menu[activeFirstLevel].children"></div>
						<component v-if="drawComponent" :is="currentComponent" />
					</div>
				</div>
			</div>
		</article>
		<base-modal :content="modalAddDocument" :show="showAddDocument" @close="showAddDocument=false"/>
	</section>
</template>

<script>
import MyOperations from '@/components/MyDocuments/MyOperations'
import PatrimonialEstate from '@/components/MyDocuments/PatrimonialEstate'
import Justificatory from '@/components/MyDocuments/Justificatory'
import OtherShared from '@/components/MyDocuments/OtherShared'
import OtherPrivate from '@/components/MyDocuments/OtherPrivate'
import ModalAddDocument from '@/components/modal/AddDocument'
import Subscription from '@/components/MyDocuments/Subscription'

import { mapGetters } from 'vuex'
export default {
	data () {
		return {
			modalAddDocument: ModalAddDocument,
			showAddDocument: false,
			drawComponent: true,
			menu: [
				{
					label: '<span class="icon-doc-cr-mission"></span> Mes opérations',
					component: MyOperations
				},
				{
					label: '<span class="icon-doc-paysage"></span> Paysages Patrimoniaux',
					component: PatrimonialEstate
				},
				{
					label: '<span class="icon-doc-others"></span> Mes Justificatifs d\'identité',
					component: Justificatory
				},
				{
					label: '<span class="icon-doc-subscription"></span> Abonnements',
					component: Subscription
				},
				{
					label: '<span class="icon-doc-lettre-mission"></span> Autres Documents',
					children: [
						{ label: 'Partagés avec mon patrimofficer', component: OtherShared },
						{ label: 'Privés', component: OtherPrivate }
					]
				}
			],
			activeFirstLevel: 0,
			activeSecondLevel: 0
		}
	},
	mounted () {
		this.$store.dispatch('fetchDocuments')
	},
	methods: {
		isActiveFirst (key) {
			return (this.activeFirstLevel === key)
		},
		isActiveSecond (key) {
			return (this.activeSecondLevel === key)
		},
		setActiveFirst (key) {
			this.activeFirstLevel = key
			this.activeSecondLevel = 0
		},
		setActiveSecond (key) {
			this.activeSecondLevel = key
		}
	},
	computed: {
		...mapGetters({
			isAnonymous: 'isAnonymous'
		}),
		currentComponent () {
			if (this.menu[this.activeFirstLevel].children) {
				if (this.activeSecondLevel !== -1) {
					return this.menu[this.activeFirstLevel].children[this.activeSecondLevel].component
				} else {
					return this.menu[this.activeFirstLevel].component
				}
			} else {
				return this.menu[this.activeFirstLevel].component
			}
		}
	}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/Documents/MyDocuments.vue